import React from 'react';
import styles from './Spinner.module.scss';
import classes from 'classnames/bind';

const cx = classes.bind(styles);

export interface SpinnerProps {
  /**
   * Size of the spinner
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Additional class
   */
  className?: string | null;
  colour?: 'salt' | 'blueberry' | 'kale' | 'grape' | 'curry' | 'tomato';
  disabled?: boolean;
}

const Spinner = ({ size = 'small', className, colour, disabled, ...props }: SpinnerProps) => {
  return (
    <div
      role="spinner"
      className={cx('spinner', {
        [`${size}`]: size,
        [`${colour}`]: colour,
        [`${className}`]: className,
        disabled,
      })}
      {...props}
    />
  );
};

export default Spinner;
